var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLink',{attrs:{"url":_vm.content.linkUrl}},[_c('AppImage',{staticClass:"image",attrs:{"content":_vm.content.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }